import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { VendorInquiry, VendorInquiryResult, VendorInquirySummary } from "src/api-service";
import { AppError } from "../../../app-store-error.types";

// **************************************************************************
//                          VENDOR INQUIRIES ACTIONS
// **************************************************************************
export const VendorInquiriesActions = createActionGroup({
    source: "Quote Vendor Inquiries",
    events: {
        // ******** GENERATE VENDOR INQUIRIES ******** //
        "Generate Vendor Inquiries": props<{ quoteId: number; versionId: number; vendorInquiries: VendorInquiry[] }>(),
        "Generate Vendor Inquiries Success": props<{ vendorInquiries: VendorInquiry[]; toastKey: string }>(),
        "Generate Vendor Inquiries Failure": props<{ error: AppError; toastKey: string }>(),

        // ******** SEND VENDOR INQUIRIES ******** //
        "Send Vendor Inquiries": props<{ quoteId: number; vendorInquiries: VendorInquiry[]; attachmentFiles: File[] }>(),
        "Send Vendor Inquiries Success": props<{ results: VendorInquiryResult[]; toastKey: string }>(),
        "Send Vendor Inquiries Failure": props<{ error: AppError; toastKey: string }>(),

        // ******** LOAD VENDOR INQUIRY SUMMARIES ******** //
        "Load Vendor Inquiry Summaries": props<{ versionId: number }>(),
        "Load Vendor Inquiry Summaries Success": props<{ summaries: VendorInquirySummary[] }>(),
        "Load Vendor Inquiry Summaries Failure": props<{ error: AppError; toastKey: string }>(),

        // ******** PREVIEW VENDOR INQUIRY ******** //
        "Preview Vendor Inquiry": props<{ blobUrl: string }>(),
        "Preview Vendor Inquiry Success": emptyProps(),

        // ******** SELECT VENDOR INQUIRIES (Step 1 → Store) ******** //
        "Select Vendor Inquiries For Sending": props<{ vendorInquiries: VendorInquiry[] }>(),

        // ******** UPDATE VENDOR INQUIRY ******** //
        "Update Vendor Inquiry CC Emails": props<{ brandCode: string; versionId: number; ccEmails: string[] }>(),
        "Update Vendor Inquiry Message": props<{ brandCode: string; versionId: number; message: string }>(),
        "Update Vendor Inquiry File Ids": props<{ brandCode: string; versionId: number; fileIds: string[] }>(),
        "Clear Vendor Inquiry": props<{ brandCode: string; versionId: number }>(),
    },
});
